(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var pins = document.querySelectorAll('[data-sa-pin]');
  var hscrolls = document.querySelectorAll('[data-sa-hscroll]');
  var ticking = false;

  function setVar(el, name, v) {
    var s = (typeof v === 'number') ? v.toFixed(4) : v;
    if (el.__v && el.__v[name] === s) return;
    (el.__v = el.__v || {})[name] = s;
    el.style.setProperty(name, s);
  }

  var HEX = [[150, 108], [192, 133], [192, 183], [150, 208], [108, 183], [108, 133], [150, 108]];
  function hexPoint(t) {
    var segs = [], total = 0, i;
    for (i = 0; i < HEX.length - 1; i++) {
      var dx = HEX[i + 1][0] - HEX[i][0], dy = HEX[i + 1][1] - HEX[i][1], l = Math.sqrt(dx * dx + dy * dy);
      segs.push(l); total += l;
    }
    var d = t * total;
    for (i = 0; i < segs.length; i++) {
      if (d <= segs[i] || i === segs.length - 1) {
        var f = clamp(d / segs[i], 0, 1);
        return [HEX[i][0] + (HEX[i + 1][0] - HEX[i][0]) * f, HEX[i][1] + (HEX[i + 1][1] - HEX[i][1]) * f];
      }
      d -= segs[i];
    }
    return HEX[0];
  }

  function process(sec, p) {
    var n = 4, x = Math.min(n - 0.0001, p * n), ch = Math.floor(x), c = clamp(x - ch, 0, 1);
    if (sec.getAttribute('data-chapter') !== String(ch)) sec.setAttribute('data-chapter', ch);
    var lis = sec.querySelectorAll('.sa-pstep');
    lis.forEach(function (li, i) {
      li.classList.toggle('is-on', i === ch);
      li.classList.toggle('is-done', i < ch);
    });
    var press = c < 0.3 ? 0 : c < 0.42 ? (c - 0.3) / 0.12 : c < 0.58 ? 1 : c < 0.7 ? 1 - (c - 0.58) / 0.12 : 0;
    setVar(sec, '--a1', ch === 0 ? clamp(c / 0.8, 0, 1) : (ch > 0 ? 1 : 0));
    setVar(sec, '--b1', ch === 1 ? clamp(c / 0.3, 0, 1) : 0);
    setVar(sec, '--b2', ch === 1 ? press : 0);
    setVar(sec, '--b3', ch === 1 ? clamp((c - 0.7) / 0.3, 0, 1) : 0);
    setVar(sec, '--b4', ch === 1 && c > 0.42 ? 1 : 0);
    var e = ch === 2 ? clamp(c / 0.85, 0, 1) : 0;
    setVar(sec, '--e1', e);
    if (ch === 2) {
      var pt = hexPoint(Math.min(1, e * 1.0));
      setVar(sec, '--nx', (pt[0] / 300 * 100).toFixed(2) + '%');
      setVar(sec, '--ny', (pt[1] / 300 * 100).toFixed(2) + '%');
    }
    setVar(sec, '--l1', ch === 3 ? clamp(c / 0.9, 0, 1) : 0);
  }

  function update() {
    ticking = false;
    var vh = window.innerHeight;
    pins.forEach(function (s) {
      var r = s.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var p = clamp(-r.top / Math.max(1, s.offsetHeight - vh), 0, 1);
      setVar(s, '--pin', p);
      if (s.classList.contains('sa-process')) process(s, p);
    });
    hscrolls.forEach(function (s) {
      var r = s.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var track = s.querySelector('.sa-products__track');
      if (!track) return;
      var p = clamp(-r.top / Math.max(1, s.offsetHeight - vh), 0, 1);
      track.style.transform = 'translate3d(' + (-p * (s.__extra || 0)).toFixed(1) + 'px,0,0)';
    });
  }
  function schedule() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

  function measure() {
    hscrolls.forEach(function (s) {
      var track = s.querySelector('.sa-products__track'), stick = s.querySelector('.sa-products__stick');
      if (!track || !stick) return;
      var last = track.lastElementChild;
      var end = last ? last.offsetLeft + last.offsetWidth + (parseFloat(getComputedStyle(track).paddingRight) || 0) : track.scrollWidth;
      var extra = Math.max(0, end - stick.clientWidth + 24);
      s.__extra = extra;
      s.style.height = (window.innerHeight + extra * 1.05) + 'px';
    });
    schedule();
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', measure);
  window.addEventListener('load', function () { measure(); setTimeout(measure, 900); });
  measure();
  update();

  document.querySelectorAll('.sa-tryon').forEach(function (sec) {
    var input = sec.querySelector('.sa-tryon__text'), text = sec.querySelector('.sa-tryon__print'), tee = sec.querySelector('.sa-tryon__tee');
    if (!input || !text || !tee) return;
    var fonts = { classic: 'Inter, sans-serif', cozy: "'Fraunces', Georgia, serif", spooky: "'Creepster', cursive" };
    function apply() {
      var v = (input.value || '').toUpperCase();
      text.textContent = v || ' ';
      var size = Math.max(14, Math.min(46, 330 / Math.max(6, v.length)));
      text.style.fontSize = size.toFixed(1) + 'px';
    }
    input.addEventListener('input', apply);
    sec.querySelectorAll('.sa-swatches').forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('.sa-sw');
        if (!b) return;
        g.querySelectorAll('.sa-sw').forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        tee.style.setProperty(g.getAttribute('data-kind') === 'tee' ? '--tee' : '--ink', b.getAttribute('data-v'));
      });
    });
    var fg = sec.querySelector('.sa-fonts');
    if (fg) fg.addEventListener('click', function (e) {
      var b = e.target.closest('.sa-fbtn');
      if (!b) return;
      fg.querySelectorAll('.sa-fbtn').forEach(function (x) { x.classList.remove('is-on'); });
      b.classList.add('is-on');
      text.style.fontFamily = fonts[b.getAttribute('data-v')] || fonts.classic;
    });
    apply();
  });

  var stats = document.querySelectorAll('.sa-stat[data-count]');
  if (stats.length && 'IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target, n = parseFloat(el.getAttribute('data-count')) || 0;
        var pre = el.getAttribute('data-prefix') || '', suf = el.getAttribute('data-suffix') || '';
        var out = el.querySelector('.sa-stat__n'), t0 = performance.now(), dur = 1500;
        (function step(now) {
          var t = clamp((now - t0) / dur, 0, 1), k = 1 - Math.pow(1 - t, 3);
          out.textContent = pre + Math.round(n * k) + suf;
          if (t < 1) requestAnimationFrame(step);
        })(t0);
      });
    }, { threshold: 0.5 });
    stats.forEach(function (s) { s.querySelector('.sa-stat__n').textContent = (s.getAttribute('data-prefix') || '') + '0' + (s.getAttribute('data-suffix') || ''); io.observe(s); });
  }
})();
